import { CapitalizedUnionMap, CapitalizedUnionValueMap, UnionMap } from '../types/union-map';

export type Environment = 'development' | 'local' | 'public';

export const Environment: CapitalizedUnionMap<Environment> = {
    Development: 'development',
    Local: 'local',
    Public: 'public',
};

export type EnvironmentShortName = 'dev' | 'local' | 'public';

export const EnvironmentShortName: CapitalizedUnionValueMap<Environment, EnvironmentShortName> = {
    Development: 'dev',
    Local: 'local',
    Public: 'public',
};

export type PanelName =
    | 'AddDevBox'
    | 'AddEnvironment'
    | 'DevMenu'
    | 'ErrorDetails'
    | 'HelpMenu'
    | 'DevBoxDetails'
    | 'RedeployEnvironment'
    | 'EnvironmentDetails'
    | 'CustomizationDetails'
    | 'Support'
    | 'UserSettings'
    | 'DeploymentLogs';

export const PanelName: UnionMap<PanelName> = {
    AddDevBox: 'AddDevBox',
    AddEnvironment: 'AddEnvironment',
    DevMenu: 'DevMenu',
    ErrorDetails: 'ErrorDetails',
    HelpMenu: 'HelpMenu',
    DevBoxDetails: 'DevBoxDetails',
    RedeployEnvironment: 'RedeployEnvironment',
    EnvironmentDetails: 'EnvironmentDetails',
    CustomizationDetails: 'CustomizationDetails',
    Support: 'Support',
    UserSettings: 'UserSettings',
    DeploymentLogs: 'DeploymentLogs',
};

export type DialogName =
    | 'ConfigureConnection'
    | 'DelayShutdown'
    | 'Confirmation'
    | 'RedeployEnvironment'
    | 'Repair'
    | 'TakeSnapshot'
    | 'ReplaceSnapshot'
    | 'Restore'
    | 'ChangeEnvironmentExpiration'
    | 'ForceDelete'
    | 'ConnectViaApp'
    | 'KeepDevBox'
    | 'McpPromotion'
    | 'ConnectWithVSCode';

export const DialogName: UnionMap<DialogName> = {
    ConfigureConnection: 'ConfigureConnection',
    DelayShutdown: 'DelayShutdown',
    Restore: 'Restore',
    Confirmation: 'Confirmation',
    RedeployEnvironment: 'RedeployEnvironment',
    Repair: 'Repair',
    TakeSnapshot: 'TakeSnapshot',
    ReplaceSnapshot: 'ReplaceSnapshot',
    ChangeEnvironmentExpiration: 'ChangeEnvironmentExpiration',
    ForceDelete: 'ForceDelete',
    ConnectViaApp: 'ConnectViaApp',
    KeepDevBox: 'KeepDevBox',
    McpPromotion: 'McpPromotion',
    ConnectWithVSCode: 'ConnectWithVSCode',
};

export type ToastName = 'Info' | 'Success' | 'Error' | 'Warning' | 'InProgress';

export const ToastName: UnionMap<ToastName> = {
    Info: 'Info',
    Success: 'Success',
    Error: 'Error',
    Warning: 'Warning',
    InProgress: 'InProgress',
};

export const TOAST_PORTAL_CONTAINER_ID = 'toast-portal-container';

export type SurfaceName = PanelName | DialogName | ToastName;

export type DismissableContentName =
    | 'PlannedMaintenance20241004Banner'
    | 'PortalSurveyInfoBanner'
    | 'SettingsMenuTeachableBubble'
    | 'ConnectViaAppTeachableBubble'
    | 'ConnectViaAppRemoteDesktopDeprecatedTeachableBubble'
    | 'ConnectViaAppTeachingPopoverForWelcomeTour'
    | 'ConnectViaAppTeachingPopoverForWelcomeTourSkipped'
    | 'DevboxSecondaryActionsTeachingPopoverForWelcomeTour'
    | 'WelcomeTourSkippedWithNoShowAgain'
    | 'CreateNewTeachingPopoverForWelcomeTour'
    | 'CreateNewTeachingPopoverForWelcomeTourSkipped'
    | 'SettingsMenuTeachingPopoverForWelcomeTour'
    | 'SettingsMenuTeachingPopoverForWelcomeTourSkipped'
    | 'HelpMenuTeachingPopoverForWelcomeTour'
    | 'WelcomeTourDialogDismissed'
    | 'ConnectWithVSCodeTeachingPopoverDismissed'
    | 'ConnectVSCodeDialogDismissed';

export const DismissableContentName: UnionMap<DismissableContentName> = {
    PlannedMaintenance20241004Banner: 'PlannedMaintenance20241004Banner',
    PortalSurveyInfoBanner: 'PortalSurveyInfoBanner',
    SettingsMenuTeachableBubble: 'SettingsMenuTeachableBubble',
    ConnectViaAppTeachableBubble: 'ConnectViaAppTeachableBubble',
    ConnectViaAppRemoteDesktopDeprecatedTeachableBubble: 'ConnectViaAppRemoteDesktopDeprecatedTeachableBubble',
    ConnectViaAppTeachingPopoverForWelcomeTour: 'ConnectViaAppTeachingPopoverForWelcomeTour',
    DevboxSecondaryActionsTeachingPopoverForWelcomeTour: 'DevboxSecondaryActionsTeachingPopoverForWelcomeTour',
    ConnectViaAppTeachingPopoverForWelcomeTourSkipped: 'ConnectViaAppTeachingPopoverForWelcomeTourSkipped',
    WelcomeTourSkippedWithNoShowAgain: 'WelcomeTourSkippedWithNoShowAgain',
    CreateNewTeachingPopoverForWelcomeTour: 'CreateNewTeachingPopoverForWelcomeTour',
    CreateNewTeachingPopoverForWelcomeTourSkipped: 'CreateNewTeachingPopoverForWelcomeTourSkipped',
    SettingsMenuTeachingPopoverForWelcomeTour: 'SettingsMenuTeachingPopoverForWelcomeTour',
    SettingsMenuTeachingPopoverForWelcomeTourSkipped: 'SettingsMenuTeachingPopoverForWelcomeTourSkipped',
    HelpMenuTeachingPopoverForWelcomeTour: 'HelpMenuTeachingPopoverForWelcomeTour',
    WelcomeTourDialogDismissed: 'WelcomeTourDialogDismissed',
    ConnectWithVSCodeTeachingPopoverDismissed: 'ConnectWithVSCodeTeachingPopoverDismissed',
    ConnectVSCodeDialogDismissed: 'ConnectVSCodeDialogDismissed',
};

export type QuickActionName = 'ConfigureRemoteDesktop' | 'ConfigureRemoteDesktopPostAvdDeprecation' | 'McpPromotion';

export const QuickActionName: UnionMap<QuickActionName> = {
    ConfigureRemoteDesktop: 'ConfigureRemoteDesktop',
    ConfigureRemoteDesktopPostAvdDeprecation: 'ConfigureRemoteDesktopPostAvdDeprecation',
    McpPromotion: 'McpPromotion',
};

export type SearchParameter =
    | 'features'
    | 'locale'
    | 'mockScenarios'
    | 'signInTenantId'
    | 'resource'
    | 'project'
    | 'devCenterUri';

export const SearchParameter: CapitalizedUnionMap<SearchParameter> = {
    Features: 'features',
    Locale: 'locale',
    MockScenarios: 'mockScenarios',
    SignInTenantId: 'signInTenantId',
    Resource: 'resource',
    Project: 'project',
    DevCenterUri: 'devCenterUri',
};
